import { Link, Outlet, useLoaderData } from 'react-router-dom';
import type { Campaign } from '../../../types/campaign.js';

export function CampaignListPage(): JSX.Element {
  const data = useLoaderData() as { campaigns: Campaign[] };
  return (
    <section className="campaign-list-page">
      <header className="page-header">
        <h2>Campaigns</h2>
        <Link className="btn btn-primary" to="new">New campaign</Link>
      </header>
      {data.campaigns.length === 0 ? <div className="empty-state">No campaigns yet.</div> : (
        <div className="manager-grid">
          {data.campaigns.map((campaign) => (
            <Link className="manager-card" to={campaign.id} key={campaign.id}>
              <h3>{campaign.name}</h3>
              <p className="status-badge">{campaign.status}</p>
              <p>{campaign.objective ?? 'No objective'}</p>
              <p>{campaign.budgetAmount ?? 0} {campaign.budgetCurrency ?? ''}</p>
            </Link>
          ))}
        </div>
      )}
      <Outlet />
    </section>
  );
}
